import "./Sidebar.scss";
import { Link, Route, Routes } from "react-router-dom";
import { StartFragment } from "./StartFragment";
import { CustomerComplaintFragment } from "./CustomerComplaintFragment";
import { CableReelFragment } from "./CableReelFragment";
import { ConsentFragment } from "./ConsentFragment";
import { ContractWithdrawalFragment } from "./ContractWithdrawalFragment";
import { ProductReturnRequestFragment } from "./ProductReturnRequestFragment";

export default function Sidebar() {
  return (
    <div id="sidebar">
      <div className="list-group">
        <Link to="/" className="list-group-item -mko-menu-header ">
          <h4>Start</h4>
        </Link>
        <hr />
        <Routes>
          <Route index element={<StartFragment />} />
          {/* <Route index element={<CustomerComplaintFragment />} /> */}
          <Route path="CustomerComplaint">
            <Route index element={<CustomerComplaintFragment />} />
            <Route path="*" element={<CustomerComplaintFragment />} />
          </Route>
          <Route path="ProductReturnRequest">
            <Route index element={<ProductReturnRequestFragment />} />
            <Route path="*" element={<ProductReturnRequestFragment />} />
          </Route>
          <Route path="ContractWithdrawal">
            <Route index element={<ContractWithdrawalFragment />} />
            <Route path="*" element={<ContractWithdrawalFragment />} />
          </Route>
          <Route path="CableReel">
            <Route index element={<CableReelFragment />} />
            <Route path="*" element={<CableReelFragment />} />
          </Route>
          <Route path="Consent">
            <Route index element={<ConsentFragment />} />
            <Route path="*" element={<ConsentFragment />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}
